import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-cart-button',
    templateUrl: './cart-button.shared.component.html',
    styleUrls: ['./cart-button.shared.component.scss']
})
export class CartButtonComponent implements OnInit {
    public badgeSize: OLO.Components.BUTTON_SIZE = 'sm';
    public bagBtnFeel: 'secondary' | 'plain' = 'secondary';
    public bagBtnBadgePosition: 'tr' = null;

    public quantity$: Observable<number>;
    @Input() public label: string = 'BAG';

    @Output() public onClick: EventEmitter<Event> = new EventEmitter(); /* Consumer <- shared-cart */

    constructor(
        public cartService: Services.CartService,
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.quantity$ = this.controllers.cart.cartTotalQuantity$();

        this._updateBagBtnFeel();
    }

    @HostListener('window:resize')
    private _updateBagBtnFeel(): void {
        setTimeout(() => {
            if (window.innerWidth > 767) {
                if (this.bagBtnFeel !== 'secondary') {
                    this.bagBtnFeel = 'secondary';
                    this.bagBtnBadgePosition = null;
                }
            } else {
                if (this.bagBtnFeel !== 'plain') {
                    this.bagBtnFeel = 'plain';
                    this.bagBtnBadgePosition = 'tr';
                }
            }
        }, 0);
    }

    public handleCartClick($event: Event): void {
        this.onClick.emit($event);

        setTimeout(() => {

            this.cartService.showPopup();
        }, 0);
    }
}
